<template><div /></template>

<script setup>
import { useToast } from 'bootstrap-vue-next'
import { getCurrentInstance, onMounted } from 'vue'

const { create } = useToast()

onMounted(() => {
  const app = getCurrentInstance().appContext.app

  // default toast options
  const defaultToastOptions = {
    position: 'bottom-center',
  }

  // global helper: accepts string or object
  app.config.globalProperties.$showToast = (opts, overrides = {}) => {
    let toastOpts = {}

    if (typeof opts === 'string') {
      toastOpts = { body: opts }
    } else if (typeof opts === 'object' && opts !== null) {
      toastOpts = { ...opts }
    } else {
      // invalid input, fallback
      toastOpts = { body: String(opts) }
    }

    // merge defaults then overrides so caller can override everything
    const finalOpts = { ...defaultToastOptions, ...toastOpts, ...overrides }
    return create(finalOpts)
  }
})
</script>
